import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import compact from 'lodash/compact'
import toUpper from 'lodash/toUpper'

import { useT } from '@galo-monitor/i18n'
import Screen from '@galo-monitor/web-components/Screen'
import TabsPanelRoutes from '@galo-monitor/web-components/TabsPanelRoutes'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

import Manufacturers from './tabs/Manufacturers'
import Pesticides from './tabs/Pesticides'

const PesticidesScreen = () => {
  const { pathname } = useLocation()
  const { routes } = useRoutes()
  const t = useT()

  const tabs = useMemo(
    () => {
      const response = []

      const addTab = tab => {
        response.push(tab)
      }

      addTab({
        route: '',
        title: toUpper(t('pesticide', { howMany: 2 })),
        Component: Pesticides
      })

      addTab({
        route: 'manufacturers',
        title: toUpper(t('manufacturer', { howMany: 2 })),
        Component: Manufacturers
      })

      return response
    },
    [t]
  )

  const crumbs = useMemo(() => compact([
    (pathname.includes('manufacturers') ? {
      title: t('manufacturer', { howMany: 2 }),
      key: 'pesticides-manufacturers-screen',
      url: '/pesticides/manufacturers',
      active: !!pathname.match('/pesticides/manufacturers')
    } : {
      title: routes.pesticides.title,
      key: 'pesticides-screen',
      url: '/pesticides',
      active: pathname.match('/pesticides')
    })
  ]), [pathname, routes.pesticides.title, t])

  return (
    <Screen title={ routes.pesticides.title } breadcrumbs={ crumbs } removeDivider>
      <TabsPanelRoutes itens={ tabs } />
    </Screen>
  )
}

export default PesticidesScreen

